import React from 'react';
import { cn } from '@/utils';

interface HeroImageProps {
  imageUrl: string;
  alt?: string;
  badge?: string;
  className?: string;
}

const HeroImage: React.FC<HeroImageProps> = ({
  imageUrl,
  alt = 'Hero image',
  badge,
  className,
}) => {
  return (
    <div className={cn('@container px-4 pt-2 pb-6', className)}>
      <div className="w-full relative overflow-hidden rounded-2xl aspect-[16/9] shadow-sm">
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-10" />
        
        {/* Background Image */}
        <div
          className="w-full h-full bg-center bg-cover bg-no-repeat transform hover:scale-105 transition-transform duration-700"
          style={{ backgroundImage: `url("${imageUrl}")` }}
          role="img"
          aria-label={alt}
        />
        
        {/* Badge */}
        {badge && (
          <div className="absolute bottom-3 left-4 z-20">
            <span className="px-2 py-1 rounded bg-primary/90 text-background-dark text-xs font-bold uppercase tracking-wider">
              {badge}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroImage;
